import { createSlice } from '@reduxjs/toolkit';
import { getEmail, getAPCMEvent, getAPCMFilteredEvent } from './userLogAction';

const initialState = {
    emails: [],
    filteredEvents: [],
    events: [],
};
export const userEventSlice = createSlice({
    name: 'user_EventSlice',
    initialState,
    reducers: {
        clearDataSource: state => {
            return {
                ...state,
              events:[],
                
            };
        },
    }
,
    extraReducers: builder => {
        builder
            .addCase(getAPCMFilteredEvent.fulfilled, (state, action) => {
                state.filteredEvents = [...action.payload];
            })
            .addCase(getEmail.fulfilled, (state, action) => {
                state.emails = [...action.payload];
            })
            .addCase(getAPCMEvent.fulfilled, (state, action) => {
                state.events = [...action.payload];
            });
    },
});
export const { clearDataSource} =
userEventSlice.actions;

export default userEventSlice.reducer;

